/* eslint-disable */
import React, { useEffect, useRef } from "react";
import { PORTALS } from "../portalConfig";
import { ParticlesCanvas } from "./ParticlesCanvas";
import "../styles/portal-entry.css";

export function SplashScreen({ portalId, userName, onComplete }) {
  const portal = PORTALS.find(p => p.id === portalId);
  const progressRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    let progress = 0;
    const tick = () => {
      progress += 0.7;
      if (progressRef.current) progressRef.current.style.width = Math.min(progress, 100) + '%';
      if (progress >= 100) {
        setTimeout(() => onComplete(portalId), 200);
        return;
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    // Small delay before starting
    const t = setTimeout(() => { rafRef.current = requestAnimationFrame(tick); }, 300);
    return () => { clearTimeout(t); if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [portalId, onComplete]);

  if (!portal) return null;

  return (
    <div className="pe-screen pe-grain">
      <ParticlesCanvas />
      <div className="pe-corner pe-c-tl" /><div className="pe-corner pe-c-tr" />
      <div className="pe-corner pe-c-bl" /><div className="pe-corner pe-c-br" />
      <div className="pe-fline pe-fline-t" /><div className="pe-fline pe-fline-b" />

      <div className="pe-splash-wrap" style={{ position: 'relative', zIndex: 'var(--z-elevated)' }}>
        <div className="pe-splash-hi">
          Welcome back, <span className="pe-splash-name">{userName}</span>
        </div>
        <div className="pe-splash-entering">Entering</div>
        <div className="pe-splash-portal">{portal.name}</div>
        <div className="pe-splash-track">
          <div className="pe-splash-fill" ref={progressRef} />
        </div>
      </div>
    </div>
  );
}
